import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'swiper/dist/js/swiper';
import 'swiper/dist/css/swiper.css';

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import SplitLine from "@/components/SplitLine.vue";
import Empty from '@/components/Empty.vue';
import ContributionTip from "@/components/ContributionTip.vue";
import Message from '@/components/Message';
import 'vue-area-linkage/dist/index.css';
import VueAreaLinkage from 'vue-area-linkage';

Vue.use(VueAreaLinkage);

Vue.component("Header", Header);
Vue.component("Footer", Footer);
Vue.component("SplitLine", SplitLine);
Vue.component("Empty", Empty);
Vue.component("ContributionTip", ContributionTip);
Vue.use(Message);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
